<template>
  <myhead @next="next" @lookmore="more">{{$route.meta.title}}</myhead>
  <img src="@/assets/img/logo.png" class="width45 pad20 mt30 auto" alt="">
  <div class="myField">
    <div v-if="$store.state.loginStatus==0" class="ml20">
      <van-field v-model="idcard" label="身份证号:" placeholder="请输入真实的身份证号" />
      <p class="Cred ml100 size13" v-show="errorMsg">{{errorMsg}}</p>
    </div>
    <div v-else-if="$store.state.loginStatus==2">
      <van-field v-model="mobile" label="手机号:" placeholder="请输入11位手机号" />
      <div class="flex">
        <div class="width65">
          <van-field v-model="smscode" placeholder="请输入验证码" label="验证码:" style="padding-right:10px" />
        </div>
        <div class="width27">
          <send-sms :typeid="2" :mobile="mobile"></send-sms>
        </div>
      </div>
    </div>
  </div>
  <div class="pad25 mt120">
    <van-button block type="primary" @click="next" round>确认</van-button>
    <!-- <div class="flex between Con mt20">
      <div @click="$router.push({path:'/login',query:{typeid:2,column_type:$route.query.column_type||0}})">验证码登录</div>
      <div @click="$router.push({path:'/login',query:{typeid:1,column_type:$route.query.column_type||0}})">密码登录</div>
    </div> -->
  </div>
</template>

<script>
//
//0第一次进来 1观念检测成功 2支付成功 3手机号绑定成功 4个人信息填写完毕 5密码设置成功 6用户名和头像设置成功 7注册考核成功 8注册审核中 9注册成功 
//10登录成功

import SendSms from "@/components/SendSms.vue";
export default {
  components: { 'send-sms': SendSms },
  data: (() => {
    return {
      idcard: '',
      mobile: '',
      smscode: '',
      password: '',
      errorMsg: ''
    }
  }),
  methods: {
    next () {
      if (this.$store.state.loginStatus == 0) {
        this.$store.state.loginInfo = {};
        localStorage.removeItem("loginInfo");
        if (this.idcard.length > 5) {
          this.ajax({ method: "post", url: "users/checkidcard", data: { idcard: this.idcard }, myData: { showMsg: false } }).then(({ data }) => {
            this.$store.state.loginInfo.birthday = data.birth;
            this.$store.state.loginInfo.idcard = this.idcard;
            localStorage.setItem("loginInfo", JSON.stringify(this.$store.state.loginInfo));
            localStorage.setItem("loginStatus", this.$store.state.loginStatus);
            this.$router.push({ path: '/sense', query: { column_type: this.$route.query.column_type || 0 } });
          }).catch(({ message }) => {
            this.errorMsg = message;
          })
        } else {
          this.errorMsg = "请输入正确的身份证号码"
        }
      } else if (this.$store.state.loginStatus == 2) {
        this.ajax({
          method: "post", url: "users/registermobile", data: {
            mobile: this.mobile,
            smscode: this.smscode,
            id: this.$store.state.loginInfo.id
          }, myData: { showMsg: false }
        }).then(() => {
          this.$store.state.loginStatus == 3;
          this.$store.state.loginInfo.mobile = this.mobile;
          localStorage.setItem("loginInfo", JSON.stringify(this.$store.state.loginInfo));
          localStorage.setItem("loginStatus", this.$store.state.loginStatus);
          this.$router.push({ path: '/register/edit', query: { title: '注册', column_type: this.$route.query.column_type || 0 } })
        }).catch(({ message }) => {
          this.errorMsg = message;
        })
      }
    }
  },
  created () {
    if (this.$store.state.loginInfo.token) {
      this.$store.state.loginInfo = {}
      localStorage.setItem("loginInfo", JSON.stringify(this.$store.state.loginInfo));
      location.reload();
    }
    let { step, loginStatus } = this.$route.query;
    if (loginStatus) {
      this.$store.state.loginStatus = Number(loginStatus);
    }
    if (step && step > 0) {
      this.step = step;
    }
  }
}
</script>

<style>
</style> 